import Reveal from '@/components/base/Reveal';
import { typographySpecimens } from '@/mocks/brand';

const scale = [
  { label: 'Titre d’affiche', cls: 'font-heading text-5xl font-semibold uppercase leading-none md:text-6xl', sample: 'Aa' },
  { label: 'Titre de section', cls: 'font-heading text-3xl font-semibold uppercase leading-none md:text-4xl', sample: 'Aa' },
  { label: 'Sous-titre', cls: 'font-heading text-2xl font-medium uppercase leading-none', sample: 'Aa' },
  { label: 'Corps de texte', cls: 'font-body text-base font-normal', sample: 'Aa' },
  { label: 'Libellé technique', cls: 'font-label text-[11px] font-semibold uppercase tracking-[0.2em]', sample: 'Aa' },
];

export default function TypeSystem() {
  return (
    <section id="typographie" className="scroll-mt-32 border-t border-background-200 bg-foreground-950 py-16 text-background-100 md:py-24">
      <div className="container-wide">
        <Reveal>
          <div className="flex items-center gap-3">
            <span className="h-px w-8 bg-accent-500" />
            <span className="label-mono text-accent-400">03 — La typographie</span>
          </div>
          <h2 className="display-title mt-5 max-w-3xl text-4xl text-background-50 md:text-5xl">
            Deux familles, une seule voix
          </h2>
          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-300 md:text-base">
            Barlow Condensed porte la puissance, Inter porte la clarté. Aucune autre police
            n’intervient : c’est ce qui rend la marque immédiatement reconnaissable d’une page à
            l’autre.
          </p>
        </Reveal>

        <div className="mt-10 grid gap-6 lg:grid-cols-2">
          {typographySpecimens.map((specimen, index) => (
            <Reveal key={specimen.name} delay={index * 110}>
              <div className="h-full rounded-lg border border-background-50/12 bg-background-50/[0.04] p-6 md:p-8">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <p className="font-heading text-xl font-semibold uppercase tracking-wide text-background-50">
                      {specimen.name}
                    </p>
                    <p className="mt-1 text-[11px] uppercase tracking-[0.16em] text-accent-400">
                      {specimen.role}
                    </p>
                  </div>
                  <span className="font-label text-[10px] tracking-[0.14em] text-background-400">
                    {specimen.weights}
                  </span>
                </div>

                <p
                  className={`mt-7 border-t border-background-50/12 pt-6 text-background-50 ${specimen.className} ${
                    index === 0
                      ? 'text-3xl leading-[1.02] md:text-[2.6rem]'
                      : 'text-lg leading-snug md:text-xl'
                  }`}
                >
                  {specimen.sample}
                </p>

                <p className="mt-5 text-xs leading-relaxed text-background-300">
                  {specimen.detail}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={160}>
          <div className="mt-6 overflow-hidden rounded-lg border border-background-50/12">
            <div className="grid grid-cols-1 divide-y divide-background-50/10 sm:grid-cols-2 sm:divide-y-0 lg:grid-cols-5 lg:divide-x lg:divide-background-50/10">
              {scale.map((item) => (
                <div key={item.label} className="flex items-center gap-4 p-5">
                  <span className={`text-background-50 ${item.cls}`}>{item.sample}</span>
                  <div className="min-w-0">
                    <p className="text-[10px] uppercase tracking-[0.14em] text-accent-400">
                      {item.label}
                    </p>
                    <p className="mt-1 truncate text-[11px] text-background-400">
                      {item.cls.includes('font-heading')
                        ? 'Barlow Condensed'
                        : item.cls.includes('font-label')
                          ? 'Inter · libellés'
                          : 'Inter'}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}